import constate from 'constate';
import { useState } from 'react';

const useProjectJobs = () => {
  const [jobsCount, setJobsCount] = useState(0);

  return { jobsCount, setJobsCount };
};

export const [ProjectJobsProvider, useProjectJobsContext] = constate(useProjectJobs);
